var DISPLAY_COUNT = 80;
var MAX_SIZE = 68;
var MIN_SIZE = 18;
var HOVER_SIZE = 86;

function initSupporterCloud() {
  var container = document.getElementById("supporter-cloud");
  if (!container) return;

  fetch("/data/supporters.json")
    .then(function (res) { return res.json(); })
    .then(function (data) {
      var supporters = [];
      for (var i = 0; i < data.length; i++) {
        var entry = data[i];
        supporters.push({
          name: entry.placeholder ? "" : entry.name,
          handle: entry.placeholder ? "" : entry.handle,
          img: entry.img,
          url: entry.placeholder ? "" : entry.url,
          placeholder: entry.placeholder
        });
      }
      var real = [];
      var placeholders = [];
      for (var j = 0; j < supporters.length; j++) {
        if (supporters[j].placeholder) {
          placeholders.push(supporters[j]);
        } else {
          real.push(supporters[j]);
        }
      }
      for (var j = placeholders.length - 1; j > 0; j--) {
        var k = Math.floor(Math.random() * (j + 1));
        var temp = placeholders[j];
        placeholders[j] = placeholders[k];
        placeholders[k] = temp;
      }
      for (var j = real.length - 1; j > 0; j--) {
        var k = Math.floor(Math.random() * (j + 1));
        var temp = real[j];
        real[j] = real[k];
        real[k] = temp;
      }
      var fillCount = Math.max(0, DISPLAY_COUNT - real.length);
      var usedPlaceholders = placeholders.slice(0, fillCount);
      var total = real.length + usedPlaceholders.length;
      var centerStart = Math.floor((total - real.length) / 2);
      var ordered = [];
      var pIdx = 0;
      for (var j = 0; j < total; j++) {
        if (j >= centerStart && j < centerStart + real.length) {
          ordered.push(real[j - centerStart]);
        } else {
          ordered.push(usedPlaceholders[pIdx++]);
        }
      }
      buildCloud(container, ordered);
    })
    .catch(function () {
      var supporters = [];
      for (var i = 1; i <= 81; i++) {
        supporters.push({
          name: "",
          handle: "",
          img: "/img/supporters/supporter-" + (i < 10 ? "0" + i : i) + ".svg",
          url: "",
          placeholder: true
        });
      }
      buildCloud(container, supporters);
    });
}

function buildCloud(container, supporters) {
  var spherePoints = [];
  var imgCache = [];
  var items = [];
  var sizeJitter = [];
  var rotX = 0;
  var rotY = 0;
  var hoveredIndex = -1;
  var hoverGrowth = 0;
  var hoverGrowSpeed = 0.08;
  var hoverPinX = 0;
  var hoverPinY = 0;
  var hoverBaseSz = 0;
  var returning = {};
  var returnSpeed = 0.025;
  var idleSpeedX = 0.003;
  var idleSpeedY = 0.0015;

  function getRightPad() {
    return window.innerWidth <= 1100 ? 0 : 40;
  }

  function distributeOnSphere(count) {
    var points = [];
    if (count <= 0) return points;
    if (count === 1) {
      points.push({ sx: 0, sy: 0, sz: 1 });
      return points;
    }
    var goldenAngle = Math.PI * (3 - Math.sqrt(5));
    var randomOffset = Math.random() * Math.PI * 2;

    for (var i = 0; i < count; i++) {
      var y = 1 - (i / (count - 1)) * 2;
      var radiusAtY = Math.sqrt(1 - y * y);
      var theta = goldenAngle * i + randomOffset;

      points.push({
        sx: Math.cos(theta) * radiusAtY,
        sy: y,
        sz: Math.sin(theta) * radiusAtY,
      });
    }
    return points;
  }

  function rotatePoint(p) {
    var cosRX = Math.cos(rotX);
    var sinRX = Math.sin(rotX);
    var cosRY = Math.cos(rotY);
    var sinRY = Math.sin(rotY);

    var y1 = p.sy * cosRX - p.sz * sinRX;
    var z1 = p.sy * sinRX + p.sz * cosRX;

    return {
      x: p.sx * cosRY + z1 * sinRY,
      y: y1,
      z: -p.sx * sinRY + z1 * cosRY,
    };
  }

  function updatePositions() {
    var w = container.offsetWidth;
    var h = container.offsetHeight;
    var rightPad = getRightPad();
    var availW = Math.max(w - rightPad, 100);
    var availH = Math.max(h, 100);
    var centerX = availW / 2;
    var centerY = availH / 2;
    var sphereRadius = Math.min(availW, availH) * 0.42;
    var isMobile = window.innerWidth <= 500;
    var maxSz = isMobile ? 54 : MAX_SIZE;
    var minSz = isMobile ? 16 : MIN_SIZE;

    for (var i = 0; i < spherePoints.length; i++) {
      var rp = rotatePoint(spherePoints[i]);
      var depthFactor = (rp.z + 1) / 2;
      var frontBlend = Math.max(0, (depthFactor - 0.5) * 2);
      var sizeCurve = depthFactor * depthFactor;
      var sz = minSz + (maxSz - minSz) * sizeCurve + sizeJitter[i] * frontBlend;
      var tx = centerX + rp.x * sphereRadius - sz / 2;
      var ty = centerY - rp.y * sphereRadius - sz / 2;
      var brightness = 0.3 + 0.7 * depthFactor * depthFactor;
      var zIdx = Math.round(depthFactor * 1000) * 100 + i;

      if (i === hoveredIndex) {
        hoverGrowth = Math.min(1, hoverGrowth + hoverGrowSpeed);
        var hoverEase = hoverGrowth * (2 - hoverGrowth);
        var isMobileSz = window.innerWidth <= 500;
        var hoverTarget = isMobileSz ? 54 : HOVER_SIZE;
        var hoverSz = hoverBaseSz + (hoverTarget - hoverBaseSz) * hoverEase;
        var hEl = items[i];
        hEl.style.transform = "translate3d(" + hoverPinX + "px," + hoverPinY + "px,0)";
        hEl.style.width = hoverSz + "px";
        hEl.style.height = hoverSz + "px";

        var rect = hEl.getBoundingClientRect();
        var containerRect = container.getBoundingClientRect();
        var tipLeft = rect.left - containerRect.left + rect.width / 2;
        var tipTop = rect.bottom - containerRect.top + 6;
        var tipW = tooltip.offsetWidth;
        if (tipLeft - tipW / 2 < 0) tipLeft = tipW / 2;
        if (tipLeft + tipW / 2 > containerRect.width) tipLeft = containerRect.width - tipW / 2;
        if (tipTop + tooltip.offsetHeight > containerRect.height) {
          tipTop = rect.top - containerRect.top - tooltip.offsetHeight - 6;
        }
        tooltip.style.left = tipLeft + "px";
        tooltip.style.top = tipTop + "px";
        continue;
      }

      var el = items[i];

      if (returning[i]) {
        var ret = returning[i];
        ret.progress = Math.min(1, ret.progress + returnSpeed);
        var ease = ret.progress * (2 - ret.progress);
        var lx = ret.x + (tx - ret.x) * ease;
        var ly = ret.y + (ty - ret.y) * ease;
        var lsz = ret.sz + (sz - ret.sz) * ease;
        el.style.transform = "translate3d(" + lx + "px," + ly + "px,0)";
        el.style.width = lsz + "px";
        el.style.height = lsz + "px";
        el.style.zIndex = zIdx;
        imgCache[i].style.filter = "brightness(" + brightness + ")";
        if (ret.progress >= 1) {
          delete returning[i];
        }
        continue;
      }

      el.style.transform = "translate3d(" + tx + "px," + ty + "px,0)";
      el.style.width = sz + "px";
      el.style.height = sz + "px";
      el.style.zIndex = zIdx;
      imgCache[i].style.filter = "brightness(" + brightness + ")";
    }
  }

  function animate() {
    rotY += idleSpeedX;
    rotX += idleSpeedY;
    updatePositions();
    requestAnimationFrame(animate);
  }

  var tooltip = document.createElement("div");
  tooltip.className = "supporter-cloud-tooltip";
  container.appendChild(tooltip);

  function createElements() {
    container.innerHTML = "";
    container.appendChild(tooltip);
    items = [];
    imgCache = [];
    sizeJitter = [];
    for (var j = 0; j < supporters.length; j++) {
      sizeJitter.push((Math.random() - 0.5) * 16);
    }

    for (var i = 0; i < supporters.length; i++) {
      var el = document.createElement("div");
      el.className = "supporter-cloud-item";

      if (!supporters[i].placeholder && supporters[i].url) {
        el.style.cursor = "pointer";
      } else {
        el.style.cursor = "default";
      }

      var img = document.createElement("img");
      img.src = supporters[i].img;
      img.alt = supporters[i].name;
      img.loading = "lazy";
      img.draggable = false;
      el.appendChild(img);

      (function (element, idx) {
        var isTouchDevice = 'ontouchstart' in window || navigator.maxTouchPoints > 0;

        element.addEventListener("mouseenter", function () {
          if (isTouchDevice) return;
          hoveredIndex = idx;
          hoverGrowth = 0;
          delete returning[idx];
          var currentTransform = element.style.transform;
          var match = currentTransform.match(/translate3d\(([^,]+)px,([^,]+)px/);
          if (match) {
            hoverPinX = parseFloat(match[1]);
            hoverPinY = parseFloat(match[2]);
          }
          hoverBaseSz = parseFloat(element.style.width) || MIN_SIZE;
          element.style.zIndex = 200000;
          imgCache[idx].style.filter = "brightness(1)";

          if (!supporters[idx].placeholder) {
            tooltip.textContent = supporters[idx].name;
            tooltip.classList.remove('touch-active');
            tooltip.onclick = null;
            tooltip.style.opacity = "1";
          }
        });

        element.addEventListener("mouseleave", function () {
          if (isTouchDevice) return;
          var el = items[idx];
          returning[idx] = {
            x: hoverPinX,
            y: hoverPinY,
            sz: parseFloat(el.style.width) || HOVER_SIZE,
            progress: 0
          };
          hoveredIndex = -1;
          tooltip.style.opacity = "0";
        });

        element.addEventListener("click", function (e) {
          if (isTouchDevice) {
            e.preventDefault();
            if (!supporters[idx].placeholder) {
              if (hoveredIndex === idx) {
                hoveredIndex = -1;
                tooltip.style.opacity = "0";
                tooltip.classList.remove('touch-active');
                tooltip.onclick = null;
                var el = items[idx];
                returning[idx] = {
                  x: hoverPinX,
                  y: hoverPinY,
                  sz: parseFloat(el.style.width) || HOVER_SIZE,
                  progress: 0
                };
              } else {
                if (hoveredIndex !== -1) {
                  var prevEl = items[hoveredIndex];
                  returning[hoveredIndex] = {
                    x: hoverPinX,
                    y: hoverPinY,
                    sz: parseFloat(prevEl.style.width) || HOVER_SIZE,
                    progress: 0
                  };
                }
                hoveredIndex = idx;
                hoverGrowth = 0;
                delete returning[idx];
                var currentTransform = element.style.transform;
                var match = currentTransform.match(/translate3d\(([^,]+)px,([^,]+)px/);
                if (match) {
                  hoverPinX = parseFloat(match[1]);
                  hoverPinY = parseFloat(match[2]);
                }
                hoverBaseSz = parseFloat(element.style.width) || MIN_SIZE;
                element.style.zIndex = 200000;
                imgCache[idx].style.filter = "brightness(1)";
                if (supporters[idx].url) {
                  tooltip.textContent = '';
                  var nameSpan = document.createElement('span');
                  nameSpan.textContent = supporters[idx].name;
                  tooltip.appendChild(nameSpan);
                  var linkImg = document.createElement('img');
                  linkImg.src = '/icons/external-link.svg';
                  linkImg.className = 'tooltip-link-icon';
                  linkImg.alt = 'Open profile';
                  tooltip.appendChild(linkImg);
                  tooltip.classList.add('touch-active');
                  tooltip.onclick = function () {
                    var url = supporters[idx].url;
                    var xMatch = url.match(/(?:twitter\.com|x\.com)\/([A-Za-z0-9_]+)/);
                    if (xMatch) {
                      var handle = xMatch[1];
                      var deepLink = 'twitter://user?screen_name=' + handle;
                      var fallback = url;
                      var didNavigate = false;
                      window.location.href = deepLink;
                      setTimeout(function () {
                        if (!didNavigate) {
                          window.open(fallback, '_blank', 'noopener,noreferrer');
                        }
                      }, 500);
                      window.addEventListener('blur', function onBlur() {
                        didNavigate = true;
                        window.removeEventListener('blur', onBlur);
                      });
                    } else {
                      window.open(url, '_blank', 'noopener,noreferrer');
                    }
                  };
                } else {
                  tooltip.textContent = supporters[idx].name;
                  tooltip.classList.remove('touch-active');
                  tooltip.onclick = null;
                }
                tooltip.style.opacity = "1";
              }
            }
            return;
          }
          if (!supporters[idx].placeholder && supporters[idx].url) {
            window.open(supporters[idx].url, "_blank", "noopener,noreferrer");
          }
        });
      })(el, i);

      container.appendChild(el);
      items.push(el);
      imgCache.push(img);
    }
  }

  spherePoints = distributeOnSphere(supporters.length);
  createElements();
  updatePositions();

  requestAnimationFrame(animate);

  var resizeTimer;
  window.addEventListener("resize", function () {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(function () {
      updatePositions();
    }, 250);
  });
}

if (document.readyState === "loading") {
  document.addEventListener("DOMContentLoaded", initSupporterCloud);
} else {
  initSupporterCloud();
}
